import { HeartBank } from "../../../managers/HeartBank.ts";
import { Crypto } from "../../../models/Crypto.ts";
import { Locker } from "./Locker.ts";
import { Crypto as Safe } from "../../../managers/Crypto.ts";
import { QrCode } from "../../../models/QrCode.ts";
import template from "./hb-silver.mjs";
import { render, html } from "lit-html";
import { repeat } from "lit-html/directives/repeat.js";
import {
    getName,
    wait,
    getHero,
    getLocation,
    loadYouTube,
    defaults,
    pickFile,
    isIOS
} from "../../global.ts";
//import { HbMe } from "../../hb-me/hb-me2.ts";
//import { effect } from "@preact/signals";
import { Me } from "../../../managers/Me.ts";
import { Stamps } from "../../../models/Stamps.ts";

import { User } from "firebase/auth";
import { fs } from "../../../firebase.ts";
import {
    collection,
    getDocs,
    query,
    orderBy,
    doc,
    getDoc,
    where,
    limit
} from "firebase/firestore";
import { Media } from "../../../managers/Media.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbDialog } from "../hb-dialog/hb-dialog.ts";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

const avatar = new URL("../../../public/avatar.webp", import.meta.url).href;
type Filter = "Ship Crew" | "Username" | "Email" | "Address"; // email not used
// ship crew = "Name" | "Phone" | "Email"; // show suggestions
// username, address => global suggestions ?
// email => no suggestion bc privacy
// address = locker or safe address = public key

// sometimes get ses lockdown error: but can pro ignore

type Voice = {
    s?: string; // "a" | "v"; // audio or video
    n?: string; // file name
    f?: string; // encrypted file name
    l?: string; // link
    e?: string; // encrypted link
};

export class HbSilver extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private media = new Media();
    private stamps = new Stamps();
    private me = new Me();
    private crypto: Crypto = new Crypto();
    private locker = new Locker();
    private safe = new Safe();
    private qrCode = new QrCode();
    private modal: ModalInterface;
    private dialog: HbDialog;

    private silver: HTMLElement;
    private stamp: HTMLButtonElement;
    private heartbeat: SVGElement;
    private back: HTMLButtonElement;

    private from: HTMLSelectElement;
    private fromIcon: HTMLSpanElement;
    private fromFootnote: HTMLParagraphElement;
    //private fromLabel: HTMLSpanElement;
    //private fromCheckbox: HTMLInputElement;
    private fromLocker: HTMLElement;
    private fromLockerAlways: HTMLElement;
    private fromLockerKeys: HTMLSelectElement;
    private fromLockerKeysAlways: HTMLSelectElement;
    private fromLockerAvatar: HTMLElement;
    private fromSafe: HTMLElement;
    private fromSafeAlways: HTMLElement; // not used
    private fromSafeKeys: HTMLSelectElement;
    private fromSafeKeysAlways: HTMLSelectElement; // not used
    private fromSafeAvatar: HTMLElement;

    //private to: HTMLSelectElement;
    private toLabel: HTMLSpanElement;
    private toCheckbox: HTMLInputElement;
    private toLocker: HTMLElement;
    private toSafe: HTMLElement;

    private toKid: HTMLInputElement;
    private toKidAdd: HTMLButtonElement;
    private toSearch: HTMLInputElement;
    private toSearchHero: HTMLElement;
    private toSearchHeroes: HTMLUListElement;
    private toSearchAdd: HTMLButtonElement;
    private toRecipients: HTMLElement;

    private toMenu: HTMLSpanElement;
    private toMenuUsername: HTMLButtonElement;
    private toMenuKid: HTMLButtonElement;
    private toMenuCrew: HTMLButtonElement;
    private toMenuEmail: HTMLButtonElement;
    private toMenuMe: HTMLButtonElement;

    private message: HTMLTextAreaElement;
    private messageLabel: HTMLSpanElement;
    private messageRecord: HTMLButtonElement;
    private messageMagic: HTMLButtonElement;
    private messageSave: HTMLButtonElement;
    private messageUndo: HTMLButtonElement;
    private messagePaste: HTMLButtonElement;
    private messageTrash: HTMLButtonElement;
    private messageCounter: HTMLSpanElement;
    private messageFootnote: HTMLParagraphElement;

    private voiceContainer: HTMLElement;
    private voiceProgress: HTMLElement;
    private voiceAudio: HTMLAudioElement;
    private voiceVideo: HTMLVideoElement;
    private voiceAttach: HTMLButtonElement;
    private voiceMicrophone: HTMLButtonElement;
    private voiceCamcorder: HTMLButtonElement;
    private voiceStop: HTMLButtonElement;
    private voiceTrash: HTMLButtonElement;
    private voice: Voice = {}; //JSON.parse(localStorage.getItem("voice") || "{}");

    private cashContainer: HTMLElement;
    private cashAmount: HTMLInputElement;

    private form: HTMLFormElement;
    private encrypt: HTMLElement;
    private encryptCheckbox: HTMLInputElement;

    // from
    //private isFromKeySafe = false;
    //private isAnonymous = false;
    private heartkeysCount = 0; // localStorage too
    private heartPublicKey = "";
    private trustkey = ""; // key id

    // to
    //private isToKeySafe = false;
    private isPrivate = false; // for message
    private searchFilter: Filter = "Username"; // default
    private recipients: any = []; //JSON.parse(localStorage.getItem("recipients") || "[]"); // filter, uid, kid, user, email

    // voice
    private mediaRecorder: MediaRecorder | null = null;
    private chunks: BlobPart[] = [];

    constructor() {
        super();
        render(template(null), this);

        this.dialog = this.querySelector("hb-dialog")!;
        this.silver = this.querySelector("#hb-silver")!;
        this.stamp = this.querySelector("#hb-silver-stamp")!;
        this.heartbeat = this.querySelector("#hb-silver-heartbeat")!;
        this.back = this.querySelector("#hb-silver-back")!;

        this.from = this.querySelector("#hb-silver-from")!;
        this.fromIcon = this.querySelector("#hb-silver-from-icon")!;
        this.fromFootnote = this.querySelector("#hb-silver-from-footnote")!;
        //this.fromLabel = this.querySelector("#hb-silver-from-label")!;
        //this.fromCheckbox = this.querySelector("#hb-silver-from-checkbox")!;
        this.fromLocker = this.querySelector("#hb-silver-from-locker")!;
        this.fromLockerAlways = this.querySelector(
            "#hb-silver-from-locker-always"
        )!;
        this.fromLockerKeys = this.querySelector(
            "#hb-silver-from-locker-keys"
        )!;
        this.fromLockerKeysAlways = this.querySelector(
            "#hb-silver-from-locker-keys-always"
        )!;
        this.fromLockerAvatar = this.querySelector(
            "#hb-silver-from-locker-avatar"
        )!;
        this.fromSafe = this.querySelector("#hb-silver-from-safe")!;
        this.fromSafeAlways = this.querySelector(
            "#hb-silver-from-safe-always"
        )!;
        this.fromSafeKeys = this.querySelector("#hb-silver-from-safe-keys")!;
        this.fromSafeKeysAlways = this.querySelector(
            "#hb-silver-from-safe-keys-always"
        )!;
        this.fromSafeAvatar = this.querySelector(
            "#hb-silver-from-safe-avatar"
        )!;

        //this.to = this.querySelector("#hb-silver-to")!;
        this.toLabel = this.querySelector("#hb-silver-to-label")!;
        this.toCheckbox = this.querySelector("#hb-silver-to-checkbox")!;
        this.toLocker = this.querySelector("#hb-silver-to-locker")!;
        this.toSafe = this.querySelector("#hb-silver-to-safe")!;

        this.toKid = this.querySelector("#hb-silver-to-kid")!;
        this.toKidAdd = this.querySelector("#hb-silver-to-kid-add")!;
        this.toSearch = this.querySelector("#hb-silver-to-search")!;
        this.toSearchHero = this.querySelector("#hb-silver-to-heroes")!;
        this.toSearchHeroes = this.toSearchHero
            .firstElementChild as HTMLUListElement;
        this.toSearchAdd = this.querySelector("#hb-silver-to-search-add")!;
        this.toRecipients = this.querySelector("#hb-silver-to-recipients")!;

        this.toMenu = this.querySelector("#hb-silver-to-dropdown")!;
        this.toMenuUsername = this.querySelector(
            "#hb-silver-to-menu-username"
        )!;
        this.toMenuKid = this.querySelector("#hb-silver-to-menu-kid")!;
        this.toMenuCrew = this.querySelector("#hb-silver-to-menu-crew")!;
        this.toMenuEmail = this.querySelector("#hb-silver-to-menu-email")!;
        this.toMenuMe = this.querySelector("#hb-silver-to-menu-me")!;

        this.message = this.querySelector("#hb-silver-message")!;
        this.messageLabel = this.querySelector("#hb-silver-message-label")!;
        this.messageRecord = this.querySelector("#hb-silver-message-record")!;
        this.messageMagic = this.querySelector("#hb-silver-message-magic")!;
        this.messageSave = this.querySelector("#hb-silver-message-save")!;
        this.messageUndo = this.querySelector("#hb-silver-message-undo")!;
        this.messagePaste = this.querySelector("#hb-silver-message-paste")!;
        this.messageTrash = this.querySelector("#hb-silver-message-trash")!;
        this.messageCounter = this.querySelector("#hb-silver-message-counter")!;
        this.messageFootnote = this.querySelector(
            "#hb-silver-message-footnote"
        )!;

        this.voiceContainer = this.querySelector("#hb-silver-voice")!;
        this.voiceProgress = this.querySelector("#hb-silver-voice-progress")!;
        this.voiceAudio = this.querySelector("#hb-silver-voice-audio")!;
        this.voiceVideo = this.querySelector("#hb-silver-voice-video")!;
        this.voiceAttach = this.querySelector("#hb-silver-voice-attach")!;
        this.voiceMicrophone = this.querySelector(
            "#hb-silver-voice-microphone"
        )!;
        this.voiceCamcorder = this.querySelector("#hb-silver-voice-camcorder")!;
        this.voiceStop = this.querySelector("#hb-silver-voice-stop")!;
        this.voiceTrash = this.querySelector("#hb-silver-voice-trash")!;

        this.cashContainer = this.querySelector("#hb-silver-cash")!;
        this.cashAmount = this.querySelector("#hb-silver-cash-amount")!;

        this.form = this.querySelector("#hb-silver-mint")!;
        this.encrypt = this.querySelector("#hb-silver-encrypt")!;
        this.encryptCheckbox = this.querySelector(
            "#hb-silver-encrypt-checkbox"
        )!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                if (!this.crypto.hasSkAndIv())
                    window.location.hash = "#/mint/ship";
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-silver",
            override: true
        };

        this.modal = new Modal(this.silver, modalOptions, instanceOptions);
    }

    connectedCallback() {
        //await this.renderLockers();
        this.addMenuListeners();
        this.addToListeners();
        this.addFromListeners();
        this.addMessageListeners();

        this.stamp.addEventListener("click", () => {
            if (
                confirm(
                    "Are you sure you want to un-link the B-Stamp you scanned?"
                )
            ) {
                localStorage.removeItem("stamp");
                this.renderStamp();
            }
        });

        this.form.addEventListener("submit", this.mint.bind(this));
        this.back.addEventListener(
            "click",
            () => (window.location.hash = "#/mint/ship")
        );
        // this.back.addEventListener(
        //     "click",
        //     () =>
        //         (window.location.hash = this.heartbank.user
        //             ? "#/mint/ship"
        //             : "#/mint/silver")
        // );

        this.heartbank.addAuthStateListener(async (user) => {
            //this.isFromKeySafe = !!user;
            render(template(user), this);
            //this.renderSafes(user);
            //this.render(user);
            this.fromIcon.textContent = user ? "🔒" : "🔐";
        });

        // Create effect to update DOM when signals change
        // effect(() => {
        //     const me = document.createElement("hb-me2") as HbMe;
        //     me.setUser(this.heartbank.user);
        //     this.fromLockerAvatar.replaceChildren(me);

        //     const me2 = document.createElement("hb-me2") as HbMe;
        //     me2.setUser(this.heartbank.user);
        //     this.fromSafeAvatar.replaceChildren(me2);

        //     // if (this.heartbank.user?.photoURL) {
        //     //     const img = document.createElement("img");
        //     //     img.src = this.heartbank.user.photoURL;
        //     //     img.classList.add("w-5", "h-5", "rounded-full");
        //     //     this.fromLockerAvatar.replaceChildren(img);
        //     //     this.fromSafeAvatar.replaceChildren(img.cloneNode());
        //     // } else {
        //     //     const span = document.createElement("span");
        //     //     span.textContent = getName();
        //     //     span.classList.add("ml-2");
        //     //     this.fromLockerAvatar.replaceChildren(span);
        //     //     this.fromSafeAvatar.replaceChildren(span.cloneNode(true));
        //     // }

        //     // Optional: Return a cleanup function
        //     // The cleanup function runs before the effect re-runs
        //     return () => {
        //         console.log("Cleaning up effect");
        //     };
        // });
    }

    private addMessageListeners() {
        this.cashAmount.addEventListener("keyup", (event: KeyboardEvent) => {
            this.renderMessage();
        });

        this.message.addEventListener("keyup", (event: KeyboardEvent) => {
            this.renderCash();
            this.renderEncrypt();
            this.renderMessage();
        });

        this.messageRecord.addEventListener("click", () => {
            this.voiceContainer.classList.toggle("hidden");
        });

        this.messageMagic.addEventListener("click", () => {
            alert("AI writing assistant coming soon...");
            //this.renderCash();
        });

        this.messageSave.addEventListener("click", () => {
            if (this.message.value.length > 0) {
                localStorage.setItem("silver", this.message.value);
                alert(
                    "Your Silver has been saved for you to continue writing later!"
                );
            } else alert("Sorry, there's currently no message to save.");
        });

        this.messageUndo.addEventListener("click", () => {
            if (
                confirm(
                    "Would you like to restore your Silver to the last saved version?"
                )
            ) {
                this.message.value = localStorage.getItem("silver") || "";
                this.renderCash();
            }
        });

        this.messagePaste.addEventListener("click", async () => {
            if (
                this.message.value.trim() === "" ||
                confirm(
                    "Would you like to replace your Silver with the writing you copied to your clipboard?"
                )
            ) {
                this.message.value = await navigator.clipboard.readText();
                this.renderCash();
            }
        });

        this.messageTrash.addEventListener("click", () => {
            if (
                this.message.value &&
                confirm("Would you like to clear your Silver and start over?")
            ) {
                this.message.value = "";
                this.renderMessage();
                this.renderCash();
                this.renderEncrypt();
            }
        });

        this.voiceAttach.addEventListener(
            "click",
            this.processVoice.bind(this, undefined, undefined)
        );
        this.voiceMicrophone.addEventListener("click", async () => {
            this.voiceMicrophone.classList.add("hidden");
            this.voiceStop.classList.remove("hidden");

            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
            const mimeType = MediaRecorder.isTypeSupported("audio/mp4")
                ? "audio/mp4"
                : "audio/webm;codecs=opus";
            this.mediaRecorder = new MediaRecorder(stream, {
                mimeType
            });

            this.mediaRecorder.ondataavailable = (e: BlobEvent) => {
                if (e.data.size > 0) this.chunks.push(e.data);
            };

            this.mediaRecorder.onstop = async () => {
                const ext = mimeType.includes("mp4") ? "m4a" : "webm";
                const blob = new Blob(this.chunks, {
                    type: mimeType
                });
                const file = new File([blob], `voice.${ext}`, {
                    type: `audio/${ext}`
                });
                this.chunks = [];
                await this.processVoice("microphone", file);
                this.voiceMicrophone.classList.remove("hidden");
                this.voiceStop.classList.add("hidden");
            };

            this.mediaRecorder.start();
        });
        this.voiceCamcorder.addEventListener(
            "click",
            this.processVoice.bind(this, "camcorder", undefined)
        );
        this.voiceStop.addEventListener("click", () =>
            this.mediaRecorder?.stop()
        );
        this.voiceTrash.addEventListener("click", async () => {
            if (confirm("Are you sure you want to remove your voice message?"))
                this.removeVoice();
        });
    }

    private async removeVoice() {
        if (this.voice.n)
            await this.media.deleteFileFromOPFS(this.voice.n, "voice");
        if (this.voice.f)
            await this.media.deleteFileFromOPFS(this.voice.f, "voice");
        if (this.voice.l) await this.media.removeFile(this.voice.l);
        if (this.voice.e) await this.media.removeFile(this.voice.e);
        this.voice = {};
        localStorage.setItem("voice", JSON.stringify(this.voice));
        this.renderVoice();
    }

    private async renderVoice() {
        if (this.voice.n) {
            const voice = await this.media.getFileFromOPFS(
                this.voice.n,
                "voice"
            );
            if (voice.type.startsWith("audio")) {
                this.voiceAudio.src =
                    this.voice.s === "v" && this.voice.l && isIOS
                        ? this.voice.l
                        : await URL.createObjectURL(voice); //this.media.fileToDataURL(voice);
                this.voiceAudio.classList.remove("hidden");
                this.voiceVideo.classList.add("hidden");
            } else {
                this.voiceVideo.src =
                    this.voice.s === "v" && this.voice.l && isIOS
                        ? this.voice.l
                        : await URL.createObjectURL(voice); //this.media.fileToDataURL(voice);
                this.voiceAudio.classList.add("hidden");
                this.voiceVideo.classList.remove("hidden");
            }
        } else {
            this.voiceAudio.src = "";
            this.voiceVideo.src = "";
            this.voiceAudio.classList.add("hidden");
            this.voiceVideo.classList.add("hidden");
        }
        this.voiceTrash.classList.toggle("hidden", !this.voice.n);
        this.voiceContainer.classList.toggle(
            "opacity-50",
            localStorage.getItem("storage") === "code" ||
                !!(this.voice.l && !this.heartbank.user)
        );
    }

    private toggleLoading(isShow: boolean) {
        const progress = this.voiceProgress.parentElement as HTMLElement;
        const buttons = this.voiceAttach.parentElement as HTMLElement;
        if (isShow) {
            progress.classList.remove("hidden");
            buttons.classList.add("hidden");
            buttons.classList.remove("inline-flex");
        } else {
            progress.classList.add("hidden");
            buttons.classList.remove("hidden");
            buttons.classList.add("inline-flex");
        }

        this.voiceAudio.pause();
        this.voiceVideo.pause();
        this.voiceProgress.style.width = "0";
        this.voiceProgress.textContent = "Please wait...";
        this.voiceAudio.classList.add("hidden");
        this.voiceVideo.classList.add("hidden");
    }

    private async processVoice(
        capture?: "microphone" | "camcorder",
        file?: File
    ) {
        if (this.voice.l && !this.heartbank.user)
            alert("Please login first in order to edit your voice message.");
        else {
            // audio file and microphone does not work on ios
            let voice =
                file ||
                (await pickFile({
                    accept: isIOS
                        ? "video/*"
                        : capture === "microphone"
                          ? "audio/*"
                          : capture === "camcorder"
                            ? "video/*"
                            : "audio/*,video/*",
                    capture
                }));
            if (voice) {
                try {
                    let isValid = false;
                    let s = "a";
                    let extension = voice.type.split("/")[1];
                    if (voice.type.startsWith("audio")) {
                        // voice message
                        extension = extension === "mpeg" ? "mp3" : extension;
                        isValid = await this.media.isAudioValid(voice);
                        if (!isValid)
                            alert(
                                "Your voice recording needs to be less than 30 minutes."
                            );
                    } else {
                        // video message
                        if (capture === "microphone" && !isIOS) {
                            this.toggleLoading(true);
                            voice =
                                await this.media.extractAudioFromVideo(voice);
                            extension = voice.type.split("/")[1];
                            isValid = await this.media.isAudioValid(voice);
                            if (!isValid)
                                alert(
                                    "Your voice recording needs to be less than 30 minutes."
                                );
                            this.toggleLoading(false);
                        } else {
                            const result =
                                await this.media.validateVideoFile(voice);
                            isValid = result.isValid;
                            s = "v";
                            if (!isValid) alert(result.errorMessage);
                        }
                    }
                    if (isValid) {
                        this.toggleLoading(true);
                        await this.removeVoice();
                        const fileName = "voice.B." + extension;
                        const efileName = "evoice.B." + extension;
                        const evoice = await this.crypto.encryptFile(voice);
                        await this.media.saveFileToOPFS(evoice, {
                            name: efileName,
                            folderPath: "voice",
                            onProgress: (percent) => {
                                this.voiceProgress.style.width = percent + "%";
                                this.voiceProgress.textContent = `Obfuscating Voice Message: ${percent}%`;
                            }
                        });
                        await this.media.saveFileToOPFS(voice, {
                            name: fileName,
                            folderPath: "voice",
                            onProgress: (percent) => {
                                this.voiceProgress.style.width = percent + "%";
                                this.voiceProgress.textContent = `Saving Voice Message: ${percent}%`;
                            }
                        });
                        if (this.heartbank.user?.phoneNumber) {
                            const e = await this.media.storeFile(
                                efileName,
                                evoice,
                                (percent) => {
                                    this.voiceProgress.style.width =
                                        percent + "%";
                                    this.voiceProgress.textContent = `Encrypting Voice Message: ${percent}%`;
                                }
                            );
                            const l = await this.media.storeFile(
                                fileName,
                                voice,
                                (percent) => {
                                    this.voiceProgress.style.width =
                                        percent + "%";
                                    this.voiceProgress.textContent = `Uploading Voice Message: ${percent}%`;
                                }
                            );
                            this.voice = {
                                s,
                                n: fileName,
                                f: efileName,
                                l,
                                e
                            };
                        } else {
                            this.voice = {
                                s,
                                n: fileName,
                                f: efileName
                            };
                        }
                        localStorage.setItem(
                            "voice",
                            JSON.stringify(this.voice)
                        );
                        if (this.message.value === "") {
                            this.message.value = "Thank You";
                            localStorage.setItem("silver", this.message.value);
                        }
                        this.toggleLoading(false);
                        this.renderVoice();
                    }
                } catch (error: any) {
                    alert(error.message);
                }
            }
        }
    }

    // TODO: show spinner if await is too long
    async show() {
        await this.renderStamp();
        this.renderHoldName(); // in case of change
        this.renderCash();
        this.renderEncrypt();

        this.renderMessage(true);
        // this.messageCounter.classList.toggle(
        //     "hidden",
        //     localStorage.getItem("storage") !== "code"
        // );
        // this.messageFootnote.classList.toggle(
        //     "hidden",
        //     localStorage.getItem("storage") !== "code"
        // );

        this.recipients = JSON.parse(
            localStorage.getItem("recipients") || "[]"
        );
        this.renderRecipients();

        this.voice = JSON.parse(localStorage.getItem("voice") || "{}");
        await this.renderVoice();
        this.voiceContainer.classList.toggle("hidden", !this.voice.n);

        loadYouTube(this);
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private async renderStamp() {
        const storage = localStorage.getItem("storage");
        const stamp = localStorage.getItem("stamp");
        const isStamp =
            stamp &&
            storage === "cloud" &&
            !(await this.stamps.isMinted(stamp));
        this.stamp.classList.toggle("hidden", !isStamp);
    }

    private async mint(event: Event) {
        event.preventDefault();
        this.dialog.show("silver");

        if (this.heartbank.user) {
            if (this.from.value === "safe") await this.safeMint();
            else await this.lockerMint();
        } else await this.lockerMint();
    }

    private async getMessage(isInitial: boolean = false) {
        const message: Record<string, any> = {};
        message.m = isInitial ? "" : this.message.value;
        message.e = this.isPrivate;
        if (this.voice.n) {
            message.v = {};
            switch (localStorage.getItem("storage")) {
                case "cloud":
                    message.v.l = message.e
                        ? await this.crypto.encryptMessage3(this.voice.e!)
                        : this.voice.l;
                    break;
                case "code":
                    message.v.l = message.e
                        ? await this.crypto.encryptMessage3(this.voice.e!)
                        : this.voice.l;
                    break;
                case "crystal":
                    const voice = await this.media.getFileFromOPFS(
                        message.e ? this.voice.f! : this.voice.n,
                        "voice"
                    );
                    message.v.n = message.e ? this.voice.f! : this.voice.n; // file name for locating in crystal + infer file type bc may be encrypted // TODO: check this bc may not be needed
                    message.v.h = await this.crypto.hashFile(voice); // hash: to verify file
                    break;
            }
        }
        return message;
    }

    private async lockerMint(
        isMinting: boolean = true,
        isInitial: boolean = false
    ) {
        const features = this.heartbank.user
            ? JSON.parse(getHero().features || "{}")
            : JSON.parse(localStorage.getItem("features") || "{}");
        const locker = features.locker || defaults.locker;
        const selected = this.querySelector<HTMLInputElement>(
            "input[name=hb-silver-from-locker]:checked"
        );

        let fromKey;
        if (await this.me.publicLockerExists()) {
            switch (locker) {
                case "public":
                    fromKey = this.trustkey;
                    break;
                case "anonymous":
                    fromKey = this.fromLockerKeys.value;
                    break;
                default:
                    fromKey =
                        selected?.value === "anonymous"
                            ? this.fromLockerKeys.value
                            : this.trustkey;
            }
        } else {
            fromKey = this.fromLockerKeysAlways.value;
        }

        // step 1
        const location: Record<string, any> = getLocation(); // can be private
        const media: any = JSON.parse(localStorage.getItem("media") || "{}"); // can be private
        const storage = localStorage.getItem("storage");
        const timelock = localStorage.getItem("timelock");
        const sk = this.crypto.getSK();
        const iv = this.crypto.getIV();

        const toRecipients = this.recipients;
        const message = await this.getMessage(isInitial);
        const isHumanityRequired = this.encryptCheckbox.checked;
        // const isHumanityRequired = this.heartbank.user
        //     ? this.encryptCheckbox.checked
        //     : false;

        const gratuity: any = {};
        gratuity.a = this.cashAmount.value.toCents(); // cents
        gratuity.c = "USD";

        const state = {
            sk,
            iv,
            location,
            media,
            storage,
            timelock:
                timelock && storage === "cloud" ? parseInt(timelock) : null,
            fromKey, // key id
            toRecipients,
            message,
            gratuity,
            isHumanityRequired
        };

        const data = await this.locker.mint(state);
        if (isMinting) {
            localStorage.setItem("remember", selected?.value || "");
            localStorage.setItem("trustkey", fromKey);
            localStorage.setItem(
                "address",
                await this.crypto.getPublicKeyString(fromKey)
            );
            this.locker.store(data, message.m);
            await this.executeMinting(data);
        }
        return data;
    }

    private async safeMint() {
        const features = JSON.parse(getHero().features || "{}");
        const safe = features.safe || "public";
        const selected = this.querySelector(
            "input[name=hb-silver-from-safe]:checked"
        ) as HTMLInputElement;

        let fromPublicKey;
        switch (safe) {
            case "public":
                fromPublicKey = this.heartPublicKey;
                break;
            case "anonymous":
                fromPublicKey = this.fromSafeKeys.value;
                break;
            default:
                fromPublicKey =
                    selected.value === "anonymous"
                        ? this.fromSafeKeys.value
                        : this.heartPublicKey;
        }
        localStorage.setItem("remember", selected.value);
        localStorage.setItem("heartkey", fromPublicKey);
        localStorage.setItem("address", fromPublicKey);

        // step 1
        const location: Record<string, any> = getLocation(); // can be private
        const media: any = JSON.parse(localStorage.getItem("media") || "{}"); // can be private
        const storage = localStorage.getItem("storage");
        const timelock = localStorage.getItem("timelock");
        const sk = this.crypto.getSK();
        const iv = this.crypto.getIV();

        const toRecipients = this.recipients;
        const message = await this.getMessage();
        const isHumanityRequired = this.encryptCheckbox.checked;

        const gratuity: any = {};
        gratuity.a = this.cashAmount.value.toCents(); // cents
        gratuity.c = "USD";

        const state = {
            sk,
            iv,
            location,
            media,
            storage,
            timelock:
                timelock && storage === "cloud" ? parseInt(timelock) : null,
            fromPublicKey,
            toRecipients,
            message,
            gratuity,
            isHumanityRequired
        };

        this.dialog.renderMessage(
            "Now verifying your humanity with passkey...",
            ""
        );
        const { data, text, color } = await this.safe.mint(state);

        if (color === "green") {
            console.log(data);
            this.locker.store(data, message.m);
            await this.executeMinting(data);
        } else {
            this.dialog.renderMessage(text, color);
            await wait(3);
            this.dialog.hide();
        }
    }

    private async executeMinting(data: any) {
        this.dialog.render1a(true);
        if (!data.isPublic) {
            const recipientsCount = data.t ? data.t.length : 0;
            switch (recipientsCount) {
                case 0:
                    this.dialog.renderMessage(
                        "Now encrypting your B-Stamp and Silver for you to view only..."
                    );
                    break;
                case 1:
                    this.dialog.renderMessage(
                        "Now encrypting your B-Stamp and Silver for you and your recipient..."
                    );
                    break;
                default:
                    this.dialog.renderMessage(
                        "Now encrypting your B-Stamp and Silver for you and each of your recipients..."
                    );
            }
            await wait(2);
            this.dialog.render1b(true);
        }
        this.dialog.render1b(true);

        this.dialog.renderMessage(
            "Now etching your signature as proof of this Silver's authenticity..."
        );
        this.dialog.render2a(true);
        await wait(1);
        this.dialog.render2b(true);
        await wait(1);

        if (data.b.s) {
            this.dialog.renderMessage(
                "Now etching HeartBank's signature as proof of your humanity..."
            );
            this.dialog.render3a(true);
            await wait(1);
            this.dialog.render3b(true);
            await wait(1);
        }
        this.dialog.render3a(true);
        this.dialog.render3b(true);

        this.dialog.hide();
        window.location.hash = "#/mint/jewel";
    }

    /// FROM

    private async renderHoldName() {
        const uid = this.heartbank.user?.uid || null;
        if (uid && this.trustkey) {
            render(
                html`
                    <hb-me
                        uid="${uid}"
                        key="${await this.crypto.getPublicKeyString(
                            this.trustkey
                        )}"
                        hidename></hb-me>
                `,
                this.fromLockerAvatar
            );
        }
        if (uid && this.heartPublicKey) {
            render(
                html`
                    <hb-me
                        uid="${uid}"
                        key="${this.heartPublicKey}"
                        hidename></hb-me>
                `,
                this.fromSafeAvatar
            );
        }
    }

    async render(user: User | null) {
        await this.renderLockers();
        await this.renderSafes(user);
        await this.renderHoldName();
        const features = user
            ? JSON.parse(getHero().features || "{}")
            : JSON.parse(localStorage.getItem("features") || "{}");
        const locker = features.locker || defaults.locker;
        const safe = features.safe || defaults.safe;

        if (user) {
            const remember =
                localStorage.getItem("remember") || defaults.remember;
            if (this.from.value === "safe") {
                this.fromLocker.classList.add("hidden");
                this.fromLockerAlways.classList.add("hidden");
                this.fromLockerAlways.classList.remove("flex");

                // always: not used
                this.fromSafe.classList.remove("hidden");
                this.fromSafeAlways.classList.add("hidden");
                this.fromSafeAlways.classList.remove("flex");

                const liPublic = this.fromSafe
                    .firstElementChild as HTMLLIElement;
                const liAnonymous = this.fromSafe
                    .lastElementChild as HTMLLIElement;
                const radioPublic = this.querySelector(
                    "#hb-silver-from-safe-public"
                ) as HTMLInputElement;
                const radioAnonymous = this.querySelector(
                    "#hb-silver-from-safe-anonymous"
                ) as HTMLInputElement;

                switch (safe) {
                    case "public":
                        liPublic.classList.remove("hidden", "border-b");
                        liAnonymous.classList.add("hidden");
                        radioPublic.checked = true;
                        break;
                    case "anonymous":
                        this.fromSafeKeys.selectedIndex = Math.floor(
                            Math.random() * this.fromSafeKeys.options.length
                        );
                        liPublic.classList.add("hidden");
                        liAnonymous.classList.remove("hidden", "border-b");
                        radioAnonymous.checked = true;
                        break;
                    case "shuffle":
                        this.fromSafeKeys.selectedIndex = Math.floor(
                            Math.random() * this.fromSafeKeys.options.length
                        );
                        liPublic.classList.remove("hidden");
                        liPublic.classList.add("border-b");
                        liAnonymous.classList.remove("hidden");
                        liAnonymous.classList.add("border-b");
                        radioPublic.checked = remember === "public";
                        radioAnonymous.checked = remember === "anonymous";
                        break;
                    case "remember": // same for logged in and out
                        const heartkey = localStorage.getItem("heartkey");
                        //if (heartkey) this.fromSafeKeys.value = heartkey;
                        const option = this.querySelector<HTMLOptionElement>(
                            `#hb-silver-from-safe-keys > option[value="${heartkey}"]`
                        );
                        if (option) option.selected = true;
                        liPublic.classList.remove("hidden");
                        liPublic.classList.add("border-b");
                        liAnonymous.classList.remove("hidden");
                        liAnonymous.classList.add("border-b");
                        radioPublic.checked = remember === "public";
                        radioAnonymous.checked = remember === "anonymous";
                        break;
                }
            } else {
                this.fromSafe.classList.add("hidden");
                this.fromSafeAlways.classList.add("hidden");
                this.fromSafeAlways.classList.remove("flex");

                if (await this.me.publicLockerExists()) {
                    this.fromLocker.classList.remove("hidden");
                    this.fromLockerAlways.classList.add("hidden");
                    this.fromLockerAlways.classList.remove("flex");

                    const liPublic = this.fromLocker
                        .firstElementChild as HTMLLIElement;
                    const liAnonymous = this.fromLocker
                        .lastElementChild as HTMLLIElement;
                    const radioPublic = this.querySelector(
                        "#hb-silver-from-locker-public"
                    ) as HTMLInputElement;
                    const radioAnonymous = this.querySelector(
                        "#hb-silver-from-locker-anonymous"
                    ) as HTMLInputElement;

                    switch (locker) {
                        case "public":
                            liPublic.classList.remove("hidden", "border-b");
                            liAnonymous.classList.add("hidden");
                            radioPublic.checked = true;
                            break;
                        case "anonymous":
                            this.fromLockerKeys.selectedIndex = Math.floor(
                                Math.random() *
                                    this.fromLockerKeys.options.length
                            );
                            liPublic.classList.add("hidden");
                            liAnonymous.classList.remove("hidden", "border-b");
                            radioAnonymous.checked = true;
                            break;
                        case "shuffle":
                            this.fromLockerKeys.selectedIndex = Math.floor(
                                Math.random() *
                                    this.fromLockerKeys.options.length
                            );
                            liPublic.classList.remove("hidden");
                            liPublic.classList.add("border-b");
                            liAnonymous.classList.remove("hidden");
                            liAnonymous.classList.add("border-b");
                            radioPublic.checked = remember === "public";
                            radioAnonymous.checked = remember === "anonymous";
                            break;
                        case "remember": // same for logged in and out
                            const trustkey = localStorage.getItem("trustkey");
                            //if (trustkey) this.fromLockerKeys.value = trustkey;
                            const option =
                                this.querySelector<HTMLOptionElement>(
                                    `#hb-silver-from-locker-keys > option[value="${trustkey}"]`
                                );
                            if (option) option.selected = true;
                            liPublic.classList.remove("hidden");
                            liPublic.classList.add("border-b");
                            liAnonymous.classList.remove("hidden");
                            liAnonymous.classList.add("border-b");
                            radioPublic.checked = remember === "public";
                            radioAnonymous.checked = remember === "anonymous";
                            break;
                    }
                } else this.renderLocker(locker);
            }
        } else {
            this.fromSafe.classList.add("hidden");
            this.fromSafeAlways.classList.add("hidden");
            this.fromSafeAlways.classList.remove("flex");
            this.renderLocker(locker);
        }
    }

    private renderLocker(locker: string) {
        this.fromLocker.classList.add("hidden");
        this.fromLockerAlways.classList.remove("hidden");
        this.fromLockerAlways.classList.add("flex");

        switch (locker) {
            case "public": // like anonymous: for when logged in without primary locker
                this.fromLockerKeysAlways.selectedIndex = 0; // always the first locker for now
                this.fromLockerKeysAlways.disabled = false;
                break;
            case "anonymous":
                this.fromLockerKeysAlways.selectedIndex = Math.floor(
                    Math.random() * this.fromLockerKeysAlways.options.length
                );
                this.fromLockerKeysAlways.disabled = true;
                break;
            case "shuffle":
                this.fromLockerKeysAlways.selectedIndex = Math.floor(
                    Math.random() * this.fromLockerKeysAlways.options.length
                );
                this.fromLockerKeysAlways.disabled = false;
                break;
            case "remember": // same for logged in and out
                const trustkey = localStorage.getItem("trustkey");
                //if (trustkey) this.fromLockerKeysAlways.value = trustkey;
                const option = this.querySelector<HTMLOptionElement>(
                    `#hb-silver-from-locker-keys-always > option[value="${trustkey}"]`
                );
                if (option) option.selected = true;
                this.fromLockerKeysAlways.disabled = false;
                break;
        }
    }

    // trustkeys
    private async renderLockers() {
        const lockers = await this.crypto.getAllKeys({
            sort: (a: any, b: any) => a.name.localeCompare(b.name)
        });

        // after lockers is important! otherwise duplicates
        this.fromLockerKeys.innerHTML = "";
        this.fromLockerKeysAlways.innerHTML = "";

        if (lockers.length === 0) {
            // checked in step 1
        } else {
            lockers.forEach((locker: any) => {
                if (getHero().trustkey === locker.key) {
                    this.trustkey = locker.id;
                } else {
                    const option = document.createElement("option");
                    option.value = locker.id;
                    option.textContent = locker.name.truncate2(17);
                    this.fromLockerKeys.append(option);
                    this.fromLockerKeysAlways.append(option.cloneNode(true));
                }
            });
        }
    }

    // heartkeys
    private async renderSafes(user: User | null) {
        if (user?.phoneNumber) {
            const keysQuery = query(
                collection(fs, "users", user.uid, "heartkeys"),
                orderBy("name")
            );
            const keysSnap = await getDocs(keysQuery);
            this.heartkeysCount = keysSnap.size;
            localStorage.setItem("heartkeysCount", keysSnap.size.toString());

            // after await
            this.fromSafeKeys.innerHTML = "";
            this.fromSafeKeysAlways.innerHTML = "";

            if (keysSnap.empty) {
                //this.isFromKeySafe = false;
                //this.fromLocker.classList.remove("hidden");
                //this.fromLocker.classList.add("flex");
                //this.fromSafe.classList.add("hidden");
                this.heartbeat.classList.remove("animate-heartbeat");
                (this.from.lastElementChild as HTMLOptionElement).selected =
                    true;
                // (this.from.parentElement as HTMLLabelElement).classList.remove(
                //     "inline-flex"
                // );
                // (this.from.parentElement as HTMLLabelElement).classList.add(
                //     "hidden"
                // );
            } else {
                //this.isFromKeySafe = true;
                if (this.from.value === "safe")
                    this.heartbeat.classList.add("animate-heartbeat");
                else this.heartbeat.classList.remove("animate-heartbeat");
                keysSnap.forEach((doc) => {
                    const { name, isPrimary } = doc.data();
                    if (isPrimary) {
                        this.heartPublicKey = doc.id;
                    } else {
                        const option = document.createElement("option");
                        option.value = doc.id;
                        option.textContent = name.truncate2(17);
                        this.fromSafeKeys.append(option);
                        this.fromSafeKeysAlways.append(option.cloneNode(true));
                    }
                });
            }
        } else {
            // no heartkeys is okay bc can use trustkeys
            // when trying to use heartkeys, alert error
        }
    }

    private addFromListeners() {
        // this.fromCheckbox.addEventListener("change", () => {
        //     this.fromLabel.textContent = this.fromCheckbox.checked
        //         ? "Stored"
        //         : "Not Stored";
        // });

        //footnote
        const radios = document.querySelectorAll<HTMLInputElement>(
            "input[name=hb-silver-from-safe]"
        );
        radios.forEach((radio) => {
            radio.addEventListener("change", (event) => {
                const target = event.target as HTMLInputElement;
                if (target.checked)
                    this.fromFootnote.classList.toggle(
                        "hidden",
                        target.value === "public"
                    );
            });
        });

        this.from.addEventListener("change", async () => {
            const icon = this.querySelector(
                "#hb-silver-from-icon"
            ) as HTMLSpanElement;
            if (this.from.value === "safe") {
                if (this.heartkeysCount === 0) {
                    this.from.value = "locker";
                    if (
                        confirm(
                            "You have not created any Safes.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-safes",
                            window.location.hash
                        );
                        window.location.hash = "#/safes";
                    }
                } else {
                    //this.fromLocker.classList.remove("flex");
                    //this.fromLocker.classList.add("hidden");
                    //this.fromSafe.classList.remove("hidden");
                    this.heartbeat.classList.add("animate-heartbeat");
                    //this.encrypt.classList.remove("hidden");
                    //this.encrypt.classList.add("flex");
                    icon.textContent = "🔒";

                    this.fromFootnote.textContent =
                        "Rotate your Safe often to protect your privacy.";
                    const selected = this.querySelector(
                        "input[name=hb-silver-from-safe]:checked"
                    ) as HTMLInputElement;
                    this.fromFootnote.classList.toggle(
                        "hidden",
                        selected.value === "public"
                    );
                    this.render(this.heartbank.user);
                }
            } else {
                const trustkeysCount = await this.crypto.count();
                if (trustkeysCount === 0) {
                    this.from.value = "safe";
                    if (
                        confirm(
                            "You have not created any Lockers.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockers",
                            window.location.hash
                        );
                        window.location.hash = "#/lockers";
                    }
                } else {
                    //this.fromLocker.classList.remove("hidden");
                    //this.fromLocker.classList.add("flex");
                    //this.fromSafe.classList.add("hidden");
                    this.heartbeat.classList.remove("animate-heartbeat");
                    //this.encrypt.classList.add("hidden");
                    //this.encrypt.classList.remove("flex");
                    icon.textContent = "🔐";

                    this.fromFootnote.textContent =
                        "Rotate your Locker often to protect your privacy.";
                    this.fromFootnote.classList.remove("hidden");
                    this.render(this.heartbank.user);
                }
            }
        });
    }

    /// TO

    // TODO: prevent adding same key as sender ?
    private async lockerToAdd(kid: string) {
        if (kid)
            try {
                if (
                    this.recipients.find(
                        (recipient: any) => recipient.kid === kid
                    )
                )
                    throw new Error("already added");

                const uid = await this.me.getUserId(kid);
                const user = uid ? await this.me.getUserProfile(uid) : null;
                // const publicKey = await this.crypto.getPublicKey(
                //     kid,
                //     "encrypt"
                // );

                // show only if primary key // allow user to send to multiple kid's even if same person
                // const docRef = doc(fs, "heartkeys", kid);
                // const docSnap = await getDoc(docRef);
                // if (docSnap.exists()) {
                //     return docSnap.data(); // or { id: docSnap.id, ...docSnap.data() } if you want the ID
                // } else {
                //     throw new Error(`No document found at /heartkeys/${kid}`);
                // }

                this.recipients.push({
                    filter: "Address",
                    kid,
                    uid,
                    user
                });
                localStorage.setItem(
                    "recipients",
                    JSON.stringify(this.recipients)
                );
                this.renderRecipients();
            } catch (error: any) {
                alert(
                    "Sorry, this locker or safe address is not supported: " +
                        error.message
                );
            }
    }

    // validate here
    private async safeToAdd(input: string = "") {
        input = input || this.toSearch.value.trim();
        if (input) {
            const kid = await this.getPublicKey();
            switch (this.searchFilter) {
                case "Ship Crew": // your crew members only: name, email, phone
                    // show suggestions
                    break;
                case "Username":
                    const username = input.toLowerCase();
                    const docRef = doc(fs, "usernames", username);
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        const { uid } = docSnap.data();
                        if (uid === this.heartbank.user!.uid)
                            this.addMe(kid); //docSnap.id
                        else this.addUsername(uid, username);
                    } else alert("This user does not exist");
                    break;
                case "Email":
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    const email = input.toLowerCase();
                    if (emailRegex.test(email)) {
                        if (email === this.heartbank.user!.email)
                            this.addMe(kid); //email
                        else this.addEmail(email);
                    } else alert("Wrong email format");
                    break;
                case "Address":
                    if (kid === input) this.addMe(kid);
                    else this.lockerToAdd(input);
                    break;
            }
        }
    }

    // deprecated: can use ship crew instead; user can manually send email themself using ios share api
    private async addEmail(email: string) {}

    private async addUsername(uid: string, username: string) {
        if (this.recipients.find((recipient: any) => recipient.uid === uid))
            alert("Already added");
        else {
            const user = await this.getUser(uid);
            if (user.heartkey || user.trustkey) {
                this.recipients.push({
                    filter: "Username",
                    uid,
                    kid: user.heartkey || user.trustkey,
                    user
                });
                localStorage.setItem(
                    "recipients",
                    JSON.stringify(this.recipients)
                );
                this.renderRecipients();
            } else
                alert(
                    `${
                        user.displayName || "@" + user.username //|| user.email
                    } has not created a Safe`
                );
        }
    }

    // deprecated: always to self
    private async addMe(kid: string | null) {
        if (
            this.recipients.find(
                (recipient: any) => recipient.uid === this.heartbank.user!.uid
            )
        )
            alert("Already added");
        else {
            if (kid) {
                this.recipients.push({
                    filter: "Self", // "Email", "Username", "Address"
                    uid: this.heartbank.user!.uid,
                    kid
                });
                localStorage.setItem(
                    "recipients",
                    JSON.stringify(this.recipients)
                );
                this.renderRecipients();
            } else alert("Please create a Safe");
        }
    }

    // deprecated: weird bugs // hb-me
    private renderRecipients2() {
        this.renderMessage();
        this.toKid.value = "";
        this.toSearch.value = "";

        if (this.recipients.length === 0) {
            this.toRecipients.classList.remove("border");
            render(
                html`
                    <li
                        class="text-gray-400 text-sm inline-flex justify-center align-middle w-full">
                        ${this.isPrivate
                            ? "Only you will be able to view this Silver."
                            : "Everyone will be able to view your Silver."}
                    </li>
                `,
                this.toRecipients
            );
        } else {
            this.toRecipients.classList.add("border");
            render(
                html`${repeat(
                    this.recipients,
                    (recipient, index) => index, // for efficient re-render
                    (recipient, index) => {
                        return html`
                            <li
                                class="${index > 0
                                    ? "border-b"
                                    : "border-0"} flex justify-between items-center w-full px-4 py-2 text-sm font-medium border-gray-200 rounded-t-lg hover:bg-gray-100 hover:text-blue-700 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                                ${this.renderRecipient(recipient, index)}
                            </li>
                        `;
                    }
                )}`,
                this.toRecipients
            );
        }
    }

    private renderRecipient(recipient: any, index: number) {
        switch (recipient.filter) {
            case "Username":
                return html`
                    <hb-me uid="${recipient.uid}"></hb-me>
                    <button
                        type="button"
                        @click=${() => {
                            this.recipients.splice(index, 1);
                            localStorage.setItem(
                                "recipients",
                                JSON.stringify(this.recipients)
                            );
                            this.renderRecipients();
                        }}>
                        🗑️
                    </button>
                `;
            case "Address":
                return html`
                    <hb-me key="${recipient.kid}"></hb-me>
                    <button
                        type="button"
                        @click=${() => {
                            this.recipients.splice(index, 1);
                            localStorage.setItem(
                                "recipients",
                                JSON.stringify(this.recipients)
                            );
                            this.renderRecipients();
                        }}>
                        🗑️
                    </button>
                `;
        }
    }

    // deprecated: hb-me does not work
    private renderRecipients() {
        this.renderMessage(true);
        this.toKid.value = "";
        this.toSearch.value = "";
        this.toRecipients.innerHTML = "";

        if (this.recipients.length === 0) {
            const li = document.createElement("li");
            //li.id = "hb-silver-to-none";
            li.classList.add(
                "text-gray-400",
                "text-sm",
                "inline-flex",
                "justify-center",
                "align-middle",
                "w-full"
            );
            li.textContent = this.isPrivate
                ? "Only you will be able to view this Silver."
                : "Everyone will be able to view your Silver.";
            this.toRecipients.appendChild(li);
            this.toRecipients.classList.remove("border");
        } else this.toRecipients.classList.add("border");

        this.recipients.forEach((recipient: any, index: number) => {
            const li = document.createElement("li");
            //li.id = `hb-silver-to-recipient-${index}`;
            li.classList.add(
                //"relative",
                "flex",
                "justify-between",
                "items-center",
                "w-full",
                "px-4",
                "py-2",
                "text-sm",
                "font-medium",
                index > 0 ? "border-b" : "border-0",
                "border-gray-200",
                "rounded-t-lg",
                "hover:bg-gray-100",
                "hover:text-blue-700",
                //"focus:z-10",
                "focus:ring-2",
                "focus:ring-blue-700",
                "focus:text-blue-700",
                "dark:border-gray-600",
                "dark:hover:bg-gray-600",
                "dark:hover:text-white",
                "dark:focus:ring-gray-500",
                "dark:focus:text-white"
            );

            const button = document.createElement("button");
            button.type = "button";
            button.textContent = "🗑️";
            button.onclick = () => {
                this.recipients.splice(index, 1);
                localStorage.setItem(
                    "recipients",
                    JSON.stringify(this.recipients)
                );
                this.renderRecipients();
            };

            //const me = document.createElement("hb-me2");
            const picture = document.createElement("picture");
            const img = document.createElement("img");
            const span = document.createElement("span");

            img.classList.add(
                "w-5",
                "h-5",
                "rounded-full",
                "inline-flex",
                "border-2",
                "border-white"
            );
            span.classList.add("ml-2");

            switch (recipient.filter) {
                case "Username2": // deprecated
                    render(
                        html` <hb-me uid="${recipient.uid}"></hb-me> `,
                        picture
                    );
                    //me.renderProfile2(recipient.user);
                    //picture.append(me);
                    break;
                case "Username":
                    //console.log(recipient.user);
                    img.src = recipient.user.photoURL || avatar;
                    img.style.borderColor = recipient.user.phoneNumber
                        ? "red"
                        : "silver"; // TODO: later add in gold and platinum
                    img.style.backgroundColor = "pink"; // TODO: aura
                    span.textContent = getName(recipient.user);
                    // span.textContent =
                    //     recipient.user.displayName ||
                    //     "@" + recipient.user.username; //|| recipient.user.email;
                    picture.append(img, span);
                    break;
                case "Address2": // deprecated
                    render(
                        html` <hb-me key="${recipient.kid}"></hb-me> `,
                        picture
                    );
                    //me.key = recipient.kid; // doesn't work: need getter/setter
                    //me.setAttribute("key", recipient.kid);
                    //picture.append(me);
                    break;
                case "Address":
                    img.src = recipient.user?.photoURL || avatar;
                    img.style.borderColor = recipient.user
                        ? "silver"
                        : "transparent"; // TODO: later add in gold and platinum
                    img.style.backgroundColor = recipient.user
                        ? "purple"
                        : "transparent"; // TODO: aura
                    span.textContent = recipient.user
                        ? getName(recipient.user)
                        : recipient.kid.truncate();
                    //span.classList.add("font-mono");
                    picture.append(img, span);
                    break;
                case "Self2": // deprecated
                    render(
                        html` <hb-me uid="${recipient.uid}"></hb-me> `,
                        picture
                    );
                    //me.uid = recipient.uid;
                    //me.setUser(this.heartbank.user);
                    //picture.append(me);
                    break;
                case "Self":
                    img.src = this.heartbank.user?.photoURL || avatar;
                    img.style.borderColor = this.heartbank.user?.phoneNumber
                        ? "red"
                        : "gold"; // TODO: later add in gold and platinum
                    img.style.backgroundColor = "skyblue"; // TODO: aura
                    span.textContent = getName();
                    picture.append(img, span);
                    break;
            }

            li.append(picture, button);
            this.toRecipients.prepend(li);
        });
    }

    private renderHeroes(search: string) {
        this.toSearchHeroes.innerHTML = "";
        const heroes = JSON.parse(localStorage.getItem("heroes") || "[]");

        for (const hero of heroes)
            if (hero.heartkey || hero.trustkey)
                if (
                    search === "" ||
                    hero.displayName
                        .toLowerCase()
                        .includes(search.trim().toLowerCase()) ||
                    hero.username
                        .toLowerCase()
                        .includes(search.trim().toLowerCase())
                    // hero.heartkey
                    //     .toLowerCase()
                    //     .includes(search.trim().toLowerCase()) ||
                    // hero.trustkey
                    //     .toLowerCase()
                    //     .includes(search.trim().toLowerCase())
                ) {
                    const li = document.createElement("li");
                    li.classList.add(
                        "flex",
                        "p-2",
                        "rounded-sm",
                        "hover:bg-gray-100",
                        "dark:hover:bg-gray-600"
                    );
                    li.dataset.uid = hero.uid;
                    li.dataset.username = hero.username;
                    li.dataset.heartkey = hero.heartkey;
                    li.dataset.trustkey = hero.trustkey;
                    li.onclick = async () => {
                        //this.toSearch.value = hero.username;
                        await this.safeToAdd(hero.username);
                        this.toSearch.value = "";
                        this.toSearch.blur();
                    };

                    const div1 = document.createElement("div");
                    div1.classList.add(
                        "flex",
                        "items-center",
                        "justify-center"
                    );
                    const img = document.createElement("img");
                    img.classList.add("w-8", "h-8", "rounded-full", "me-2");
                    img.src = hero.photoURL || avatar;
                    div1.appendChild(img);

                    const div2 = document.createElement("div");
                    div2.classList.add("ms-2", "text-sm");
                    const label = document.createElement("label");
                    const span = document.createElement("span");
                    //span.classList.add("font-medium", "block");
                    span.textContent =
                        hero.displayName ||
                        hero.heartkey?.truncate2(15) ||
                        hero.trustkey?.truncate2(15) ||
                        "No Name";
                    const p = document.createElement("p");
                    p.classList.add(
                        "text-xs",
                        "font-normal",
                        "text-gray-500",
                        "dark:text-gray-300"
                    );
                    p.textContent = `@${hero.username}`;
                    label.append(span, p);
                    div2.appendChild(label);

                    li.append(div1, div2);
                    this.toSearchHeroes.appendChild(li);
                }

        if (this.toSearchHeroes.childElementCount === 0) {
            const li = document.createElement("li");
            li.classList.add(
                "text-gray-400",
                "text-sm",
                "inline-flex",
                "justify-center",
                "align-middle",
                "w-full",
                "p-2"
            );
            li.textContent = "No Zero Heroes Found";
            this.toSearchHeroes.appendChild(li);
        }
    }

    private async addHero() {
        if (this.toSearchHeroes.childElementCount > 0) {
            const hero = this.toSearchHeroes.firstElementChild as HTMLLIElement;
            await this.safeToAdd(hero.dataset.username);
            this.toSearch.blur();
        }
    }

    private addToListeners() {
        this.toKid.addEventListener("keypress", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.lockerToAdd(this.toKid.value);
            }
        });
        // this.toKidAdd.addEventListener(
        //     "click",
        //     this.lockerToAdd.bind(this, this.toKid.value) // value does not update
        // );
        this.toKidAdd.addEventListener("click", () =>
            this.lockerToAdd(this.toKid.value)
        );

        this.toSearch.addEventListener("focus", () => {
            if (this.searchFilter === "Username") {
                this.renderHeroes(this.toSearch.value);
                this.toSearchHero.classList.remove("hidden");
            }
        });
        this.toSearch.addEventListener("blur", async () => {
            if (this.searchFilter === "Username") {
                await wait(0.1); // needed for click select
                this.toSearchHero.classList.add("hidden");
            }
        });
        this.toSearch.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Enter") {
                event.preventDefault();
                this.addHero();
                //this.safeToAdd();
            }
        });
        this.toSearch.addEventListener("keyup", (event: KeyboardEvent) => {
            if (this.searchFilter === "Username")
                this.renderHeroes(this.toSearch.value);
        });
        this.toSearchAdd.addEventListener("click", async () => {
            if (this.toSearch.value.trim()) {
                this.addHero();
                //this.safeToAdd();
            } else {
                await wait(0.2); // TODO: weird jag
                this.toSearch.focus();
            }
        });

        this.toCheckbox.addEventListener("change", () => {
            // this.toLabel.textContent = this.toCheckbox.checked
            //     ? "Private"
            //     : "Public";
            // this.messageLabel.textContent = this.toCheckbox.checked
            //     ? "Secret"
            //     : "Message";
            this.message.placeholder = this.toCheckbox.checked
                ? "What secret note would you like to engrave on your Silver?"
                : "What public message would you like to engrave on your Silver?";

            const li = this.querySelector(
                "#hb-silver-to-none"
            ) as HTMLLIElement;
            if (this.toCheckbox.checked) {
                this.isPrivate = true;
                if (li)
                    li.textContent =
                        "Only you will be able to view this Silver.";
            } else {
                this.isPrivate = false;
                if (li)
                    li.textContent =
                        "Everyone will be able to view your Silver.";
            }

            this.renderEncrypt();
            this.renderMessage(); // need to be at the end!
        });

        this.encryptCheckbox.addEventListener("change", () =>
            this.renderMessage()
        );

        // this.to.addEventListener("change", () => {
        //     if (this.to.value === "safe") {
        //         this.toLocker.classList.remove("flex");
        //         this.toLocker.classList.add("hidden");
        //         this.toSafe.classList.remove("hidden");
        //         this.toSafe.classList.add("flex");
        //     } else {
        //         this.toLocker.classList.remove("hidden");
        //         this.toLocker.classList.add("flex");
        //         this.toSafe.classList.add("hidden");
        //         this.toSafe.classList.remove("flex");
        //     }
        // });
    }

    private addMenuListeners() {
        this.toMenuUsername.addEventListener(
            "click",
            this.selectMenu.bind(this, "Username")
        );
        this.toMenuKid.addEventListener(
            "click",
            this.selectMenu.bind(this, "Address")
        );
        this.toMenuCrew.addEventListener(
            "click",
            this.selectMenu.bind(this, "Ship Crew")
        );
        this.toMenuEmail.addEventListener(
            "click",
            this.selectMenu.bind(this, "Email")
        );
        this.toMenuMe.addEventListener("click", async () => {
            const kid = await this.getPublicKey();
            const toggle = this.toMenu.parentElement as HTMLButtonElement;
            toggle.click();
            this.addMe(kid);
        });
    }

    private selectMenu(filter: Filter) {
        const toggle = this.toMenu.parentElement as HTMLButtonElement;
        toggle.click();
        this.searchFilter = filter;
        this.toMenu.textContent = filter;
        this.toSearch.value = "";
        this.toSearch.focus();

        switch (filter) {
            case "Username":
                this.toSearch.placeholder = "Search Username";
                break;
            case "Address":
                this.toSearch.placeholder = "Enter Locker or Safe";
                break;
            case "Ship Crew":
                this.toSearch.placeholder = "Search for Crew Member";
                break;
            case "Email":
                this.toSearch.placeholder = "Enter Email Address";
                break;
        }
    }

    /// SILVER

    private async renderMessage(isWait = false) {
        if (localStorage.getItem("storage") === "code") {
            if (isWait) {
                //await wait(2); // need to wait bc reload cause error
                await this.renderLockers();
                await this.renderSafes(this.heartbank.user);
            }

            let data = await this.lockerMint(false, true);
            this.qrCode.setInitialCount(data);
            data = await this.lockerMint(false);

            const countSpan = this.messageCounter
                .firstElementChild as HTMLSpanElement;
            const limitSpan = this.messageCounter
                .lastElementChild as HTMLSpanElement;
            this.messageCounter.classList.remove("hidden");
            this.messageFootnote.classList.remove("hidden");

            const props = this.qrCode.selectBestQrVersion(data);
            if (props) {
                const { version, count, limit, size, recovery } = props;
                countSpan.textContent = count.toString();
                limitSpan.textContent =
                    limit.toString() + (version <= 40 ? "+" : "");
                //countSpan.style.color = version <= 40 ? "" : "orange";
                //limitSpan.style.color = version <= 40 ? "" : "orange";
                this.messageCounter.style.color = version <= 40 ? "" : "orange";
                this.messageFootnote.textContent =
                    count === 0
                        ? ""
                        : `Your Silver QR Code will have a size of ${size}x${size} with ${recovery}% recoverability.`;
            } else {
                if (countSpan.textContent === "") countSpan.textContent = "0";
                limitSpan.textContent =
                    limitSpan.textContent?.replace("+", "") || "0";
                //countSpan.style.color = "red";
                //limitSpan.style.color = "red";
                this.messageCounter.style.color = "red";
                this.messageFootnote.textContent =
                    "Your Silver has grown too large to store as a QR Code. Please go back and choose a 3B Crystal instead.";
            }
        } else {
            this.messageCounter.classList.add("hidden");
            this.messageFootnote.classList.add("hidden");
        }
    }

    private renderCash() {
        this.cashContainer.classList.toggle(
            "hidden",
            this.message.value.length === 0
        );
    }

    private renderEncrypt() {
        const location = getLocation();
        const media = JSON.parse(localStorage.getItem("media") || "{}");
        if (
            this.message.value.length !== 0 &&
            (!location.e || !media.e || !this.toCheckbox.checked)
        ) {
            // this.heartbank.user &&
            this.encrypt.classList.remove("hidden");
            this.encrypt.classList.add("flex");
            //this.mintElement.classList.add("border-t");
        } else {
            this.encrypt.classList.add("hidden");
            this.encrypt.classList.remove("flex");
            //this.mintElement.classList.remove("border-t");
        }

        let treasure = "";
        if (!location.e && !media.e && !this.toCheckbox.checked)
            treasure = "Location, Diamonds and Silver";
        else if (!location.e && !media.e) treasure = "Location and Diamonds";
        else if (!media.e && !this.toCheckbox.checked)
            treasure = "Diamonds and Silver";
        else if (!location.e && !this.toCheckbox.checked)
            treasure = "Location and Silver";
        else if (!location.e) treasure = "Location";
        else if (!media.e) treasure = "Diamonds";
        else if (!this.toCheckbox.checked) treasure = "Silver";

        const info = this.encrypt.lastElementChild as HTMLLabelElement;
        info.innerHTML = `Would you like to encrypt your <strong>${treasure}</strong> so that
                                only humans can view it?`;
    }

    // HELPERS

    private async getPublicKey(
        uid: string | null = null
    ): Promise<string | null> {
        if (!uid) uid = this.heartbank.user!.uid;
        const user = await this.getUser(uid);
        //if (user)
        return user!.heartkey; // might not have been created
        //return null;
    }

    private async getUser(uid: string): Promise<any> {
        const docRef = doc(fs, "users", uid);
        const docSnap = await getDoc(docRef);
        //if (docSnap.exists())
        return docSnap.data();
        //return null;
    }

    // need index // show all keys belong to sender? pro not
    private async getPublicKey2(uid: string | null = null) {
        if (!uid) uid = this.heartbank.user!.uid;
        const q = query(
            collection(fs, "users", uid, "heartkeys"),
            where("isPrimary", "==", true),
            limit(1)
        );

        const querySnapshot = await getDocs(q);
        const doc = querySnapshot.docs[0];

        if (doc) return doc.id; // { id: doc.id, ...doc.data() };
        return null;
    }
}
